/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink, Link } from 'react-router-dom';
import Logo from './partials/Logo';
import DashboardApi from '../../api/DashboardApi';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool
}

const defaultProps = {
  navPosition: '',
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false
}

const HeaderDash = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  displayState,
  setDisplayState,
  ...props
}) => {

  const [isActive, setIsactive] = useState(false);
  
  const nav = useRef(null);
  const hamburger = useRef(null);

  const dashApi = new DashboardApi();
  var [checksRemaining, setChecksRemaining] = useState("");

  useEffect(() => {
    dashApi.GetChecksRemaining().then(x => {
      console.log("Checks remaining " + x.checksRemaining);
      setChecksRemaining(x.checksRemaining);
    }).catch(x => {
      console.log("Error loading checks remaining")
    })
  }, [displayState]);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);
    return () => {
      document.removeEventListener('keydown', keyPress);
      document.addEventListener('click', clickOutside);
      closeMenu();
    };
  });  

  const openMenu = () => {
    document.body.classList.add('off-nav-is-active');
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsactive(true);
  }

  const closeMenu = () => {
    document.body.classList.remove('off-nav-is-active');
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  }

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  }

  const history = useHistory();

  const logout = () => {
      localStorage.setItem("token", "");
      history.push("/Login");
  }

  const clickOutside = (e) => {
    if (!nav.current) return
    if (!isActive || nav.current.contains(e.target) || e.target === hamburger.current) return;
    closeMenu();
  }  

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  return (
    <header
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-header-inner',
            bottomDivider && 'has-bottom-divider'
          )}>
          <Logo />
          {!hideNav &&
            <>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={
                  classNames(
                    'header-nav',
                    isActive && 'is-active'
                  )}>
                <div className="header-nav-inner">
                <ul className={
                    classNames(
                      'list-reset text-xs',
                      navPosition && `header-nav-${navPosition}`
                    )}>
                    <li className="clickable">
                      <NavLink exact to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="clickable">
                      <NavLink exact to="/Account">Account</NavLink>
                    </li>
                    <li className="padding clickable" onClick={logout}>
                      Logout
                    </li>
                    <li className="padding">
                      {checksRemaining} Checks Remaining
                    </li>
                  </ul>
                  {!hideSignin &&
                    <ul
                      className="list-reset header-nav-right"
                    >
                      <li>
                        <Link to="/Upgrade" className="button button-primary button-wide-mobile button-sm" onClick={closeMenu}>Upgrade</Link>
                      </li>
                    </ul>}
                </div>
              </nav>
            </>}
        </div>
      </div>
    </header>
  );
}

HeaderDash.propTypes = propTypes;
HeaderDash.defaultProps = defaultProps;

export default HeaderDash;